import * as React from 'react'

export default () => (
  <svg width='118' height='32' viewBox='0 0 118 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M62.7986 8L60.5452 19.1227H59.9403L59.9047 18.9889L57.0463 8H52.5897L49.7284 19.1227H49.1531L46.8374 8H42.0665L46.1258 24.0865H52.2191L54.4726 15.7312H55.0359L55.0715 15.8619L57.3191 24.0865H63.3798L67.4717 8H62.7986Z'
      fill='#280C2D'
    />
    <path d='M75.3058 8H70.4222V24.0865H75.3058V8Z' fill='#280C2D' />
    <path
      d='M89.6568 8H78.2766V11.6709H81.2358V24.0865H86.1194V11.6709H89.6568V8Z'
      fill='#280C2D'
    />
    <path d='M97.5381 8H92.6545V24.0865H97.5381V8Z' fill='#280C2D' />
    <path
      d='M112.002 24.0865H117.333L111.818 15.6509L111.889 15.5498L117.224 8H112.13L107.881 14.2242H106.644V8H101.823V24.0865H106.644V17.9248H107.883L112.002 24.0865Z'
      fill='#280C2D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM18.8809 17.9966L22.839 9.33333H26.2522L20.3828 22.1876H17.3956L16.1454 19.4579L17.852 15.7384L18.8809 17.9966ZM18.1342 9.33615L12.2648 22.1904H9.27759L5.33333 13.5575H8.74653L10.7767 17.9994L14.7348 9.33615H18.1342Z'
      fill='#280C2D'
    />
  </svg>
)
